<script>
import headerBeleuchtung from "@/assets/beleuchtung_header.jpg";
import {mapGetters} from "vuex";
import RightColumnGroup from "@/components/layout/RightColumnGroup.vue";
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";
export default {
  name: "BeleuchtungView",
  components: {Breadcrumbs, RightColumnGroup},
  data: () => ({
    header: headerBeleuchtung,
  }),
  computed: {
    ...mapGetters('user', ['userCommunePartner', 'userCommuneRegionalLeader', "userCommuneName", "getDashboardCommunePartners"]),
    showDetails() {
      const communes = ["NEW-Mitarbeiter", "Hückelhoven"];

      return communes.includes(this.userCommuneName);
    },
    sidebarConfig() {
      return {
        showRegionalLeiter: false,
        personsInCharge: this.getDashboardCommunePartners,
        interestingLinks: [
          { id: 0, title: "NEW Netz GmbH", link: "https://www.new-netz.de/" },
          { id: 1, title: "Störungsmeldung", link: "https://www.new-netz.de/stoerungsannahme/strassenbeleuchtung" }
        ]
      }
    }
  }
}
</script>

<template>
  <div class="beleuchtung-view min-height-100">
    <v-img
        :src="header"
        aspect-ratio="2.1333"
        max-height="450px"
        class="beleuchtung-header"
    >
      <span
          class="custom-header-text new-font-bold white--text"
          style="position: absolute; bottom: 20px; left: 35px;"
      >
        Straßenbeleuchtung
      </span>
    </v-img>
    <v-row no-gutters class="beleuchtung-content">
      <v-col cols="12" sm="8" class="new-wrapper px-10 py-4">
        <breadcrumbs />
        <p class="font-weight-bold">
          Die NEW Netz beleuchtet die Kommunen
        </p>
        <p>
          Licht an, Licht aus? Beim Thema Straßenbeleuchtung leistet die NEW Netz GmbH weit mehr als das! Straßen, Wege und Plätze energiesparend, umweltschonend und sicher ausleuchten - diese Anforderungen gilt es im Auftrag der Städte und Gemeinden zu erfüllen. Die NEW Netz GmbH tauscht Leuchten oder Leuchtmittel regelmäßig aus und setzt moderne LED-Technik ein. Sie erarbeitet im Zuge der Wartung und Sanierung umfassende Beleuchtungskonzepte in Zusammenarbeit mit der Stadt. <br><br>
          Sehen Bürger:innen defekte Beleuchtung, können sie die Störung digital melden. Per App “stoerung24” auf ihrem Smartphone oder auch per Browser im gleichnamigen Internetportal. Hier können sie den grün markierten Laternenstandort auf einer Karte auswählen und die Störungsmeldung abgeben. Dazu können sie zusätzlich ein Foto übermitteln. Nach dem Absenden wechselt der Punkt auf der Karte die Farbe. Er ist nun in Rot als gestört markiert und für jeden Nutzer sichtbar. So gibt es keine Mehrfachmeldungen zu dem Standort. Nun beginnt die Arbeit für die NEW Netz GmbH: Der Monteur erhält die Information sofort auf sein Smartphone und kann sich um die Reparatur kümmern. Über den Störungsverlauf wird der Meldende informiert, wenn er bei der Eingabe seine E-Mail-Adresse angibt. <br><br>
          Sind Masten oder Leuchten beschädigt, fehlen die Masttüren - also die Wartungsklappen im Mast - oder ist ein ganzer Straßenzug unbeleuchtet, bittet die NEW Netz GmbH um sofortige telefonische Meldung unter der Störungsrufnummer. Erforderliche Sicherungsmaßnahmen werden dann eingeleitet <br><br>
        </p>
        <iframe src="https://www.stoerung24.de/?mandant=NEWAG&apikey=5FACDD4D-D0F1-492B-8143-FE620E99EA27" style="width: 100%; aspect-ratio: 1.33" />

        <template v-if="showDetails">
          <p class="font-weight-bold">Umrüstung der Straßenbeleuchtung</p>
          <p>Bis Mai 2027 werden alle 5.080 alten Leuchten in Hückelhoven von der NEW auf sparsame LED-Technik umgestellt. Das spart im Schnitt 67 Prozent Energie und rund 480 Tonnen CO₂ pro Jahr. Die neuen Leuchten sind langlebig, senken die Betriebskosten und machen die Beleuchtung klimafreundlich. Der Fortschritt bei der Umrüstung kann über die Karte live mitverfolgt werden.</p>
          <iframe style="width: 100%; aspect-ratio: 1.33" src="https://www.luxdata-easy.com/public/home/1f844468-71f0-42b8-8aac-8a013662ee7e" />

          <p class="font-weight-bold">Anleitung zur Nutzung der Sanierungsübersichtskarte </p>
          <p>Die Sanierungsübersichtskarte bietet einen schnellen Überblick über den aktuellen Stand der Lichtpunktsanierungen. </p>
          <p class="font-weight-bold">Farbkennzeichnung der Lichtpunkte </p>
          <ul>
            <li>Rote Punkte = Leuchtentausch offen, ist terminiert </li>
            <li>Grüne Punkte = Leuchtentausch erfolgt </li>
          </ul>
          <p class="font-weight-bold">Lichtpunkt suchen </p>
          <ol>
            <li>Geben Sie oben links in das Suchfeld eine Adresse ein. </li>
            <li>Wählen Sie den gewünschten Lichtpunkt auf der Karte aus. </li>
            <li>Nach dem Anklicken öffnet sich die Detailansicht des Lichtpunktes. </li>
          </ol>
          <br>
          <p class="font-weight-bold">Detailansicht nutzen </p>
          <p>Die Spaltendarstellung der Detailansicht kann über die Ansichtsoptionen I, II und III individuell angepasst werden. In der Detailansicht werden unter anderem folgende Informationen angezeigt: </p>
          <ul>
            <li>Geplanter Sanierungszeitpunkt </li>
            <li>Status der Sanierung </li>
            <li>Bereits durchgeführte Sanierungen </li>
          </ul>
          <p class="font-weight-bold">Nutzung am PC, Tablet oder Smartphone </p>
          <p>
            Auf größeren Bildschirmen werden Karte und Detailansicht gleichzeitig angezeigt. Dadurch können weitere Lichtpunkte direkt auf der Karte gesucht und ausgewählt werden, ohne die Seite verlassen zu müssen.
            <br><br>
            Auf Smartphones wird nach Auswahl eines Lichtpunkts die Detailansicht angezeigt. Um einen anderen Lichtpunkt auszuwählen, muss die Seite anschließend neu geladen werden.
          </p>
        </template>

      </v-col>
      <v-col
          cols="12"
          sm="4"
          class="contact_container pl-4"
      >
        <RightColumnGroup
            :communePartner="userCommunePartner"
            :communeRegionalLeader="userCommuneRegionalLeader"
            :contentObject="sidebarConfig"
        />
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.beleuchtung-view {
  display: flex;
  flex-direction: column;
}

.beleuchtung-header {
  flex-shrink: 0;
}

.beleuchtung-content {
  flex: 1;
}
</style>
